import { IonButton, IonCol, IonGrid, IonPage, IonRow, IonToast } from '@ionic/react';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { RootState } from '../App';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { SiteLogoBanner } from '../components/SiteLogoBanner';
import { useLoading } from '../hooks/useQuirkLoading';
import { RegistrationState, setErrorMessage, verify } from '../state/registrationSlice';
// eslint-disable-next-line css-modules/no-unused-class
import onboardingStyles from '../styles/onboarding.module.css';
export const VerifyAccount = () => {
	const state: RegistrationState = useSelector<RootState, RegistrationState>(state => state.registration);
	const registered = state.registered;
	useLoading({
		isLoading: registered === 'verifying',
		message: 'Please wait...'
	});
	const verifySent = useRef(false);
	const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
	const { token } = useParams<{ token: string }>();
	useEffect(() => {
		if (token && !verifySent.current) {
			dispatch(verify({ token }));
			verifySent.current = true;
		}
	}, [dispatch, token]);
	const history = useHistory();
	const resend = () => {
		history.push('/users/resend');
	};
	return (
		<IonPage>
			<QuirkIonContent flush>
				<div className="login-container">
					<SiteLogoBanner siteName={true} />
					<div className="space20" />
					<h4 className={`${onboardingStyles.title}`}>Verify your account</h4>
					<IonToast
						isOpen={registered === 'verified'}
						duration={1500}
						message="Successfully Verified, please login"
						position="top"
						onDidDismiss={() => {
							history.push('/main/settings/login');
						}}
					/>
					<IonToast
						isOpen={state.errorMessage !== ''}
						duration={1500}
						message={state.errorMessage}
						color="danger"
						position="top"
						onDidDismiss={() => dispatch(setErrorMessage(''))}
					/>
					<IonGrid>
						<IonRow class="ion-justify-content-center">
							<IonCol>
								<IonButton onClick={() => resend()} expand="block">
									Resend registration email
								</IonButton>
							</IonCol>
						</IonRow>
						<IonRow class="ion-justify-content-center">
							<a
								onClick={() => {
									history.push('/main/settings/login');
								}}
								href="/main/settings/login"
							>
								Login
							</a>
						</IonRow>
					</IonGrid>
				</div>
			</QuirkIonContent>
		</IonPage>
	);
};
